module.exports = __webpack_public_path__ + "img/icon_shopping_list_button.a6e3e7d0.svg";